import React from 'react'

const Watchlist = ({ width, height }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14.028 14.028"
      >
        <path
          data-name="Path 941"
          d="M15.128 17.091H5.024a1.962 1.962 0 0 1-1.962-1.962V5.025a1.962 1.962 0 0 1 1.962-1.962h10.1a1.962 1.962 0 0 1 1.966 1.962v10.1a1.962 1.962 0 0 1-1.962 1.962zM5.024 3.848a1.177 1.177 0 0 0-1.177 1.177v10.1a1.177 1.177 0 0 0 1.177 1.177h10.1a1.177 1.177 0 0 0 1.177-1.177v-10.1a1.177 1.177 0 0 0-1.177-1.177z"
          style={{ fill: '#b1b1b1' }}
          transform="translate(-3.062 -3.063)"
        />
        <path
          data-name="Path 942"
          d="M6.436 8.067a.407.407 0 0 1-.277-.115.392.392 0 0 1 0-.555.4.4 0 0 1 .277-.115h.79A.4.4 0 0 1 7.5 7.4a.392.392 0 0 1-.277.67zm0 3.31a.41.41 0 0 1-.277-.115.392.392 0 0 1 0-.556.4.4 0 0 1 .277-.115h.79a.409.409 0 0 1 .277.115.392.392 0 0 1 0 .556.4.4 0 0 1-.277.115zm0 3.312a.407.407 0 0 1-.277-.115.392.392 0 0 1 0-.555.4.4 0 0 1 .277-.115h.79a.4.4 0 0 1 .277.115.392.392 0 0 1-.277.67zm3.148-6.623a.392.392 0 1 1 0-.785H15a.392.392 0 0 1 0 .785zm0 3.311a.392.392 0 1 1 0-.785H15a.392.392 0 0 1 0 .785zm0 3.31a.392.392 0 1 1 0-.785H15a.392.392 0 0 1 0 .785z"
          transform="translate(-3.704 -3.971)"
          style={{ fill: '#b1b1b1' }}
        />
      </svg>
    </div>
  )
}

export default Watchlist
